import { assertUnreachable } from "@repo/utils";
import { type ActionType, createAction, getType } from "typesafe-actions";

import { type SearchOrderResult } from "../../hooks/searchOrder";

export interface AddOrderState {
  defaultPartyId?: string;
  customerInfo?: {
    id: string;
    name: string;
    email: string;
    isRegistered: boolean;
  };
  orders?: SearchOrderResult[];
  orderNumbers?: string[];
  searchValue?: string;
}

export const AddOrderStateDefault: AddOrderState = {
  customerInfo: undefined,
  orderNumbers: undefined,
  searchValue: undefined,
};

export type AddOrderStateActions = typeof addOrderStateActions;
export const addOrderStateActions = {
  setCustomer: createAction("SET_CUSTOMER")<AddOrderState["customerInfo"]>(),
  setOrderNumbers:
    createAction("SET_ORDER_NUMBERS")<AddOrderState["orderNumbers"]>(),
  setOrders: createAction("SET_ORDERS")<AddOrderState["orders"]>(),
  setSearchValue: createAction("SET_SEARCH_VALUE")<string | undefined>(),
};

export function addOrderStateReducer(
  state: AddOrderState,
  action: ActionType<AddOrderStateActions>
): AddOrderState {
  switch (action.type) {
    case getType(addOrderStateActions.setCustomer):
      return {
        ...state,
        customerInfo: action.payload,
        orders: undefined,
      };
    case getType(addOrderStateActions.setOrderNumbers):
      return {
        ...state,
        orderNumbers: action.payload,
      };
    case getType(addOrderStateActions.setOrders):
      return {
        ...state,
        searchValue: undefined,
        orders: action.payload,
      };
    case getType(addOrderStateActions.setSearchValue):
      return {
        ...state,
        searchValue: action.payload,
        orders: undefined,
      };
  }
  assertUnreachable(action);
}
